import { render, staticRenderFns } from "./CbsRefAvailabilityWizard.vue?vue&type=template&id=066dfe9a&scoped=true"
import script from "./CbsRefAvailabilityWizard.vue?vue&type=script&lang=js"
export * from "./CbsRefAvailabilityWizard.vue?vue&type=script&lang=js"
import style0 from "./CbsRefAvailabilityWizard.vue?vue&type=style&index=0&id=066dfe9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066dfe9a",
  null
  
)

export default component.exports